@if (content()) {
  <div class="nordic-blue-900-text text-icon-primary ps-xlarge-y" [class.col-1-12]="isFullWidth()">
    @if (title()) {
      <fcom-heading-tag
        data-testid="heading-tag"
        class="heading-tag"
        [level]="headerLevel()"
        [extraClasses]="headerFontLevel()"
        >{{ title() }}</fcom-heading-tag
      >
    }
    <div class="flex column-wrapper">
      @for (item of articles(); track item.article.contentId) {
        <div data-testid="article-with-icons-article" class="flex flex--column flex-1 flex--basis0">
          <cms-rich-text
            class="flex-1"
            [content]="item.article"
            [extraClasses]="link() ? '' : 'mr-large-b'"
            [headerLevel]="item.headerLevel"
            [headerStyles]="item.headerStyles"
          />
          @for (relatedLink of item.links; track $index) {
            <div class="flex nowrap mr-large-b">
              <fcom-link
                [href]="relatedLink.url"
                [external]="relatedLink.external"
                [openInNewTab]="relatedLink.openInNewTab"
                >{{ relatedLink.title }}</fcom-link
              >
            </div>
          }
        </div>
      }
    </div>

    @if (link()) {
      <div class="flex flex--end mr-large-t">
        <a
          [finLink]="link().target?.url"
          [external]="link().target?.external"
          [attr.target]="link().target?.openInNewTab ? '_blank' : null"
          class="flex flex--middle nordic-blue-900-text text-icon-primary no-underline underline-hover font-body-medium-bold"
          data-testid="article-with-icons-cta"
        >
          <span class="title">{{ link().teaserTitle }}</span>
          <span class="cta">
            <fcom-icon class="icon-medium" [name]="SvgLibraryIcon.ARROW_RIGHT" />
          </span>
        </a>
      </div>
    }
  </div>
}
